export default __webpack_public_path__ + "static/char-s-62-jp-6cfb94c9c2b9a2613eb2190b59f385ac.webp";